module.exports = __webpack_public_path__ + "img/iccard2.4b073da6.svg";